import React, { useCallback, useMemo, useRef } from 'react';

import { AdFoxContext } from '../../../../../../shared/serp/components/adfox/utils/context';
import { ContentRow } from '../../../components/ContentRow';
import { AuctionTitleContainer } from '../AuctionTitleContainer';
import { GeoContainer } from '../GeoContainer';
import { IdenticalOffersLinkContainer } from '../IdenticalOffersLinkContainer';
import { LabelsListContainer } from '../LabelsListContainer';
import { PriceContainer } from '../PriceContainer';
import { ResizableContainer } from '../ResizableContainer';
import { SimilarLinkContainer } from '../SimilarLinkContainer';
import { TitleContainer } from '../TitleContainer';

interface IOfferGeneralInfoContainerProps {
  isNewHighlighting: boolean;
  mortgageBanner?: React.ReactNode;
}

export function OfferGeneralInfoContainer({ isNewHighlighting, mortgageBanner }: IOfferGeneralInfoContainerProps) {
  const updateCb = useRef<() => void | undefined>();

  // после загрузки банера пересчитываем количество доступных строк описания
  const handleAdFoxLoaded = useCallback(() => {
    if (updateCb.current) {
      updateCb.current();
    }
  }, []);

  const handleSetUpdateCb = useCallback((cb: () => void) => {
    updateCb.current = cb;
  }, []);

  const contextValue = useMemo(() => ({ onLoad: handleAdFoxLoaded }), [handleAdFoxLoaded]);

  return (
    <>
      <TitleContainer />
      <LabelsListContainer />
      <GeoContainer />
      <AuctionTitleContainer />
      <AdFoxContext.Provider value={contextValue}>
        <PriceContainer
          isNewHighlighting={isNewHighlighting}
          MortgageAdFoxBanner={<ContentRow>{mortgageBanner}</ContentRow>}
        />
      </AdFoxContext.Provider>
      <ResizableContainer setCallback={handleSetUpdateCb} />
      <SimilarLinkContainer />
      <IdenticalOffersLinkContainer />
    </>
  );
}
